export default __webpack_public_path__ + "static/media/euro.8b3d8f4f.svg";